// An address from one of our emails' links (#…&email=<address>; the fullstack's
// shared/emails/prefillLinks.js, Seán's spec, 2026-10-27): kept for this tab only
// (sessionStorage), taken out of the address so the pages read their own hash as before
// (router/index.js), and used once: Sign In pre-filled (SignIn/Contact.vue), passed on to the
// fullstack (useUrlWithAuth.js), then thrown away as soon as anyone is signed in. As the
// fullstack's app/utils/prefillEmail.js.

const STORAGE_KEY = "vizbi-prefill-email";
const EMAIL_PART = /^email=/i;

// "#register&email=jane%40x.org" → {email: "jane@x.org", hash: "#register"}; no address: null
export function takeHashEmail(hash) {
  const parts = String(hash || "").replace(/^#/, "").split("&");
  const found = parts.find((part) => EMAIL_PART.test(part));
  if (found === undefined) return null;
  let email = "";
  try {
    email = decodeURIComponent(found.slice("email=".length)).trim();
  } catch {
    // a malformed address: none
  }
  const rest = parts.filter((part) => part !== found).join("&");
  return {email: email.includes("@") ? email : "", hash: rest ? `#${rest}` : ""};
}

export function storePrefillEmail(email) {
  try {
    sessionStorage.setItem(STORAGE_KEY, email);
  } catch {
    // storage refused (a private window): no pre-fill
  }
}

export function getPrefillEmail() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

// a link to the fullstack with the address after its "#" (its own prefillEmail.js takes it)
export function addPrefillEmail(url) {
  const email = getPrefillEmail();
  if (!email || /[#&]email=/.test(url)) return url;
  const [base, fragment] = url.split(/#(.*)/s);
  const part = `email=${encodeURIComponent(email)}`;
  return fragment ? `${base}#${fragment}&${part}` : `${base}#${part}`;
}

export function clearPrefillEmail() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // storage refused (a private window): no pre-fill
  }
}
